"use client";

import { useEffect, useState } from "react";
import { getBrowserSupabaseClient } from "@/core/auth/session.client";
import { useAuth } from "@/state/globalStore";

export default function useBrowserAuthSession() {
  const { user } = useAuth();
  const [hasBrowserSession, setHasBrowserSession] = useState(false);

  useEffect(() => {
    let isMounted = true;

    getBrowserSupabaseClient()
      .auth.getUser()
      .then(({ data }) => {
        if (isMounted) {
          setHasBrowserSession(!!data.user);
        }
      })
      .catch(() => {
        if (isMounted) {
          setHasBrowserSession(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return !!user || hasBrowserSession;
}
